import { render, staticRenderFns } from "./PictureChooser.vue?vue&type=template&id=28c28615&scoped=true&"
import script from "./PictureChooser.vue?vue&type=script&lang=ts&"
export * from "./PictureChooser.vue?vue&type=script&lang=ts&"
import style0 from "./PictureChooser.vue?vue&type=style&index=0&id=28c28615&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c28615",
  null
  
)

export default component.exports